import { ChainId } from 'boltr-sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x57aC6DF707Ca70741D23Ff1587A3d71f536c0B07',
  [ChainId.TESTNET]: '0x57aC6DF707Ca70741D23Ff1587A3d71f536c0B07'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
